export default {
  path: 'task/:id',
  name: 'TaskView',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/TaskView.vue')
}
